import TalentList from "../components/TalentList";

const ListTalentPage = () => {
  return (
    <TalentList />
  );
};

export default ListTalentPage;
